import React from 'react'

type CarouselCtx = {
  currentSlideIndex: number
  containerWidth: number
  isSwiping: boolean
  maxCardIndex: number
  notifyUpdatedCards?: () => void
}

type CarouselCardCtx = {
  cardIndexOnSlide: number
  cardIndex: number
  cardsOnSlide: number
  cardIsVisible: boolean
}

export const CarouselContext = React.createContext<CarouselCtx>({
  currentSlideIndex: 0,
  containerWidth: 0,
  isSwiping: false,
  maxCardIndex: 0,
})

export const CarouselCardContext = React.createContext<CarouselCardCtx>({
  cardIndexOnSlide: 0,
  cardIndex: 0,
  cardsOnSlide: 0,
  cardIsVisible: false,
})
